<template>
  <v-menu
      v-model="showMenu"
      :disabled="disableMenu"
      transition="scale-transition"
      offset-y
  >
    <template v-slot:activator="{ on: onMenu }">
      <v-tooltip bottom :disabled="disableTooltip">
        <template v-slot:activator="{ on: onTooltip }">
          <div v-if="checkDeliveryItem(schedule)" :style="getDeliveryIconStyle(schedule)" v-on="onMenu">
            <div v-on="onTooltip">
              <img v-if="checkDeliveryState(schedule)" src="../assets/archive.png" class="delivery-icon">
              <img v-else src="../assets/archive_grey.png" class="delivery-icon">
            </div>
          </div>

          <div v-else :style="getScheduleStyle(schedule)" v-on="onMenu">
            <div
              class="inside-bar"
              :class="{ 'align-center': checkRestSchedule(schedule) }"
              v-on="onTooltip"
              :style="getInsideScheduleStyle(schedule)"
            >
              <template v-if="checkReservedSchedule(schedule)">
                <div v-if="checkRestSchedule(schedule)">휴식</div>
                <div v-else class="schedule-text-box">
                  <div>{{ getStartTime(schedule.item.startTime) }}</div>
                  <div>{{ schedule.item.customerName }}</div>
                  <div>{{ getSuburbanString(schedule.item) }}/편도</div>
                  <div>{{ schedule.item.departure }}</div>
                  <div>→</div>
                  <div>{{ schedule.item.destination }}</div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <slot name="tooltipInfo" :item="schedule"></slot>
      </v-tooltip>
    </template>
    <v-list>
      <slot name="menuInfo" :item="schedule"></slot>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    schedule: {
      type: Object,
    },
    selectedDate: {
      type: String
    },
    unitHeight: { // 분당 높이
      type: Number,
      default: 1
    },
    disableMenu: {
      type: Boolean,
      default: false,
    },
    disableTooltip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    getScheduleStyle(schedule) {
      const borderColor = this.getScheduleBorder(schedule);
      return {
        position: "absolute",
        backgroundColor: schedule.color,
        top: this.getSchedulePosition(schedule),
        height: this.getScheduleHeight(schedule),
        color: this.getScheduleFontColor(schedule),
        boxShadow: 'inset 0px 0px 2px 1px '+ borderColor, //rgba(153, 153, 153, 0.76)',
        width: "110px",
        borderRadius: "5px"
      };
    },
    getInsideScheduleStyle(schedule) {
      if (
          schedule.item &&
          schedule.item.resrvState &&
          schedule.item.resrvState.configValue === "rs_done"
      )
        return {
          borderRadius: "5px",
          background: "#7F7F7F",
          color: '#fff'
        };
    },
    checkReservedSchedule(schedule) {
      return schedule.category === 'reservation'
          || schedule.category === 'breakTime'
    },
    checkRestSchedule(schedule) {
      return schedule.category === 'breakTime'
    },
    getStartTime(startTime) {
      return this.$func.stringToDatetime(startTime).format('HH:mm:ss')
    },
    getSchedulePosition(schedule) {
      const startTime = this.$func.stringToDatetime(schedule.startTime);
      const baseTime = this.$func.stringToDate(this.selectedDate);
      baseTime.set({hours: 0, minutes: 0, seconds: 0});
      const startPosition = this.$moment
          .duration(startTime.diff(baseTime))
          .asMinutes();

      return startPosition * this.unitHeight + "px";
    },
    getScheduleHeight(schedule) {
      const startTime = this.$func.stringToDatetime(schedule.startTime);
      const endTime = this.$func.stringToDatetime(schedule.endTime);
      const duration = this.$moment
          .duration(endTime.diff(startTime))
          .asMinutes();

      return duration * this.unitHeight + "px";
    },
    getScheduleFontColor(schedule) {
      return schedule.category === 'reservation' ? '#000' : '#fff';
    },
    getScheduleBorder(schedule) {
      return this.getHexToAgbColor(schedule.color) || schedule.color;
    },
    getHexToAgbColor(hexColor) {
      if (hexColor.indexOf("#") < 0 || hexColor.length !== 7) {
        return null;
      }
      let r = hexColor.substring(1, 3);
      let g = hexColor.substring(3, 5);
      let b = hexColor.substring(5, 7);

      r = parseInt(r, 16) - 30;
      r = r < 0 ? 0 : r;
      g = parseInt(g, 16) - 30;
      g = g < 0 ? 0 : g;
      b = parseInt(b, 16) - 30;
      b = b < 0 ? 0 : b;

      return "rgb(" + r + ", " + g + ", " + b + ")";
    },
    checkDeliveryItem(schedule) {
      return schedule.category === 'delivery';
    },
    checkDeliveryState(schedule) {
      return schedule.item.state.configValue === 'dvry_to_be_done';
    },
    getDeliveryIconStyle(schedule) {
      return {
        position: "absolute",
        top: this.getSchedulePosition(schedule),
      }
    },
    getSuburbanString(item) { // 시내 / 시외만 구분
      if (!item || !item.fareType) {
        return '';
      }

      return item.fareType.startsWith('suburban') ? '시외' : '시내';
    },

  }
};
</script>
<style scoped>
.inside-bar {
  width: 100%;
  height: 100%;
  display: block;
  padding: 0 5px;
  font-size: 10px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-line;
  text-align: left;
}

.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.delivery-icon {
  height: 16px;
}
</style>